export default __webpack_public_path__ + "static/media/category-2.d3d4f96b.webp";